
import { defineComponent } from "vue";
import { useStore } from "@/store";

export default defineComponent({
  name: "App",
  components: {},
  setup() {
    const store = useStore();
    const resize = () => {
      // set custom vh for SP.
      const vh = window.innerHeight / 100;
      document.documentElement.style.setProperty("--vh", `${vh}px`);

      // set vmin
      const vmin =
        window.innerHeight < window.innerWidth ? vh : window.innerWidth / 100;
      document.documentElement.style.setProperty("--vmin", `${vmin}px`);

      // set media type.
      const newMedia = window.matchMedia("(min-width: 769px)").matches
        ? "pc"
        : "sp";
      store.commit("setMediaType", newMedia);
    };
    resize();

    // add resize event listener.
    window.addEventListener("resize", resize);
  }
});
